















import { Component } from 'vue-property-decorator';
import { PaginationMixin } from '@/utils/mixin';
import { UserRole, UserRoleArr, UserRoleState } from '@/config/map.conf';
import { State } from 'vuex-class';
import AddRgUser from './components/add-rg-user.vue';
import PersonTable from './components/user-person-table.vue';
import OrganizationTable from './components/user-organization-table.vue';

/**
 * rg成员列表
 *
 * @author xiaokunyu
 * @date 01/11/2019
 */
@Component({
    components: {
        AddRgUser,
        PersonTable,
        OrganizationTable
    }
})
export default class RgUser extends PaginationMixin {
    @State(state => state.cti.permission.rg_user)
    permission: boolean;

    userList: CommonTypes.RgUserItem[] = [];
    addUserVisible: Boolean = false;
    rgId: number = 0;
    userRole: CommonTypes.mapObject = UserRole;
    userRoleArr: any[] = UserRoleArr;
    tableLoading: Boolean = true;
    $mtd: any;
    userType: string = 'RGADMIN';
    userRoleState: any = UserRoleState;

    created() {
        this.rgId = parseInt(this.$route.query.rgId as string, 10);
    }
}
